import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import replaceWebpackDynamicImport from './utils/ReplaceDynamicImport';

window.replaceWebpackDynamicImport = replaceWebpackDynamicImport;

async function  bootstrap(): Promise<void> {
  ReactDOM.render(<App />, document.getElementById('root'));
}

bootstrap();
